import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { grey } from "designSystem/styles/color";

const CubeIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props} viewBox="0 0 16 16">
			<path d="M14 11C14 11.2534 13.86 11.4734 13.6467 11.5867L8.38 14.5467C8.27333 14.6267 8.14 14.6667 8 14.6667C7.86 14.6667 7.72667 14.6267 7.62 14.5467L2.35334 11.5867C2.24646 11.5305 2.15701 11.4462 2.09472 11.3427C2.03243 11.2393 1.99967 11.1208 2 11V5.00004C2 4.74671 2.14 4.52671 2.35334 4.41337L7.62 1.45337C7.72667 1.37337 7.86 1.33337 8 1.33337C8.14 1.33337 8.27333 1.37337 8.38 1.45337L13.6467 4.41337C13.86 4.52671 14 4.74671 14 5.00004V11ZM8 2.76671L4.02667 5.00004L8 7.23337L11.9733 5.00004L8 2.76671ZM3.33334 10.6067L7.33333 12.86V8.38671L3.33334 6.14004V10.6067ZM12.6667 10.6067V6.14004L8.66667 8.38671V12.86L12.6667 10.6067Z" fill={grey[900]} />
		</SvgIcon>
	);
};

export default CubeIcon;